import { NativeModules, NativeEventEmitter, EmitterSubscription } from 'react-native';
import type { BluestackPreference } from './Preference';

const { BluestackRewardedAdManager } = NativeModules;
const eventEmitter = new NativeEventEmitter(
    NativeModules.BluestackRewardedAdManager
);

export const BluestackRewardedAd = {
    /**
     * Load Rewarded ad for a given placementId and shows it if it is autoDisplay
     * @param placementId — The placement Id of the ad
     * @param bsPreference — Preferences for the ad to display
     */
    loadAd(placementId: string, bsPreference?: BluestackPreference) {
        let autoDisplay: boolean = false; // TODO - provide auto display option when native is ready.
        let preferenceJSON: string = '{}';
        if (bsPreference != null) {
            preferenceJSON = bsPreference.getPreferenceJSON();
        }

        return BluestackRewardedAdManager.loadAd(
            placementId,
            autoDisplay,
            preferenceJSON
        );
    },

    /**
     * Display an loaded Rewarded ad
     */
    displayAd(): Promise<number> {
        return BluestackRewardedAdManager.displayAd();
    },

    /**
     * Add Rewarded ad Event Listener
     * @param listener — the listener function
     * @returns a subscription object that can be used to remove the listener
     */
    addEventListener(listener: (event: any) => void): EmitterSubscription {
        return eventEmitter.addListener('RewardedAdEvent', listener);
    },

    /**
     * Remove a specific Rewarded ad Event Listener
     * @param subscription — the subscription object returned by addEventListener
     */
    removeEventListener(subscription: EmitterSubscription) {
        subscription.remove();
    },

    /**
     * Remove all Rewarded ad Event Listeners
     */
    removeAllEventListeners() {
        eventEmitter.removeAllListeners('RewardedAdEvent');
    },
};
